export interface UserState {
  username: string;
  twilioToken: string;
  roomAssignment?: RoomAssignment
  lobbyStep: LobbyStep;
  isInteracting: boolean;
  networkQuality?: NetworkQuality;
  showNetworkQualityHelp: boolean;
  showAudioTest: boolean;
  privateChatEnabled: boolean;
}

export enum RoomAssignment {
  GreenRoom = "greenRoom",
  LiveBroadcast = "liveBroadcast"
}

export enum LobbyStep {
  EnterName = 1,
  RequestPermission = 2,
  SelectMediaDevices = 3,
  Waiting = 4,
}

export enum NetworkQuality {
  Error = "error",
  Poor = "poor",
  Fair = "fair",
  Good = "good",
  Excellent = "excellent"
}